"use client";

import PricingCtaSection from "@/components/ui/pricing-cta-section";
import { STATS } from "@/lib/constants";

export default function ResidentialPricingCta() {
  return (
    <PricingCtaSection
      id="residential-cta-heading"
      heading={`${STATS.ips} IPs. ${STATS.countries} countries. One click to start.`}
    />
  );
}
